import { useState } from "react";
import toast from "react-hot-toast";
import axios from 'axios';


const BoltIcon = () => (
  <svg className="w-3.5 h-3.5" fill="#4ade80" viewBox="0 0 24 24">
    <path d="M13 2L4.5 13.5H11L10 22L19.5 10.5H13L13 2Z" />
  </svg>
);

const inputClass =
  "w-full bg-[#eef2ec] text-gray-700 text-sm px-4 py-3.5 rounded-xl outline-none placeholder-gray-400 border border-transparent focus:border-green-400 transition-colors duration-200 resize-none";

export default function GetInTouch() {
  const [form, setForm] = useState({
    name: "", email: "", number: "", projectType: "", query: "",
  });
    const [sent, setSent] = useState(false);
    const [errors, setErrors] = useState({});
      const [sending, setSending] = useState(false);

const handle = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
    if (errors[e.target.name]) setErrors({ ...errors, [e.target.name]: "" });
  };

  const validate = () => {
    const e = {};
    if (!form.name.trim()) e.name = "Name is required";
    if (!form.email.trim()) e.email = "Email is required";
    else if (!/\S+@\S+\.\S+/.test(form.email)) e.email = "Invalid email";
    if (!form.number.trim()) e.number = "Phone number is required";
    else if (!/^\+?[\d\s\-]{8,15}$/.test(form.number))
      e.number = "Invalid phone number";
    if (!form.projectType) e.projectType = "Select a project type";
    if (!form.query.trim()) e.query = "Message is required";
    return e;
  };

  const handleSubmit = async () => {
    try {
      const e = validate();
      if (Object.keys(e).length > 0) {
        setErrors(e);
        return;
      }
      setSending(true);
      await axios.post(`${process.env.REACT_APP_API_URL}/enquiry/create`, form);

      toast.success("Inquiry submitted successfully!");
      reset();
    } catch (error) {
      console.log("Error", error);
    } finally {
      setSending(false);
      setSent(true);
    }
  };

  const reset = () => {
    setForm({ name: "", email: "", number: "", projectType: "", query: "" });
    setErrors({});
    setSent(false);
  };

  return (
    <div
      className="w-full flex flex-col lg:flex-row"
      style={{ minHeight: "700px", fontFamily: "'Barlow', 'Montserrat', sans-serif" }}
    >
      {/* ── Left: Google Map ── */}
      <div className="flex-1 lg:w-full" style={{ minHeight: "600px" }}>
        <iframe
          title="Location Map"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3712.01877336564!2d86.9221003!3d21.5069846!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a1cf5de937b2ab7%3A0xef11347c561bf90f!2sVISHWARAJA%20ENTERPRISES!5e0!3m2!1sen!2sin!4v1776322302477!5m2!1sen!2sin"
          width="100%"
          height="100%"
          style={{ border: 0, minHeight: "500px", display: "block" }}
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        />
      </div>

      {/* ── Right: Contact Form ── */}
      <div
        className="flex-1 lg:w-1/3 flex flex-col justify-center rounded-xl px-10 py-14 absolute right-20 bg-transparent/60 lg:my-10 "
        // style={{ background: "#f8faf6" }}
      >
        {/* Header */}
        <div className="mb-8">
          <div className="flex items-center gap-1.5 mb-3">
            <BoltIcon />
            <span className="text-sm font-rajdhani font-bold tracking-[0.2em] uppercase" style={{ color: "#4ade80" }}>
              CONTACT NOW
            </span>
          </div>
          <h2
           className="font-bold text-gray-200 font-rajdhani text-2xl md:text-4xl lg:text-[45px] leading-relaxed "
            style={{ letterSpacing: "-0.02em" }}
          >
            Get In Touch With Us
          </h2>
        </div>

        {/* Form */}
        <div className="flex flex-col gap-4">
          {/* Row 1 */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <input
              name="name"
              value={form.name}
              onChange={handle}
              placeholder="Name"
              className={inputClass}
            />
            <input
              name="email"
              type="email"
              value={form.email}
              onChange={handle}
              placeholder="Email"
              className={inputClass}
            />
          </div>

          {/* Row 2 */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <input
              name="number"
              value={form.number}
              onChange={handle}
              placeholder="number"
              className={inputClass}
            />
            <input
              name="projectType"
              value={form.projectType}
              onChange={handle}
              placeholder="Subject"
              className={inputClass}
            />
          </div>

          {/* Message */}
          <textarea
            name="query"
            value={form.query}
            onChange={handle}
            placeholder="Write a Message"
            rows={6}
            className={inputClass}
          />

          {/* Submit */}
          <div className="mt-2">
            <button
              onClick={handleSubmit}
              className="font-black text-sm px-10 py-4 rounded-full transition-all duration-200 hover:opacity-90 hover:shadow-lg hover:scale-105"
              style={{
                background: "linear-gradient(135deg, #6ee85a 0%, #3dcc40 100%)",
                color: "#1a2e0a",
                boxShadow: "0 6px 20px rgba(74,222,128,0.4)",
                letterSpacing: "0.02em",
              }}
            >
              Submit Now
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}